import { render, staticRenderFns } from "./activityEditExamSubjects.html?vue&type=template&id=0ff5427c&scoped=true&external"
import script from "./activityEditExamSubjects.vue?vue&type=script&lang=js"
export * from "./activityEditExamSubjects.vue?vue&type=script&lang=js"
import style0 from "./activityEditExamSubjects.css?vue&type=style&index=0&id=0ff5427c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff5427c",
  null
  
)

export default component.exports